module.exports = {
  googleSiteVerification: 'Os1eE0RAeu9b-5KiPxDoccOyid6fqoCnYk_aCvTmqlY',
}